import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  Input,
} from '@continuum/ui';

const emailSchema = yup.object({
  email: yup
    .string()
    .email('Please enter a valid email')
    .required('Email is required'),
});

type EmailForm = yup.InferType<typeof emailSchema>;

interface EmailStepProps {
  isLoading: boolean;
  error: string | null;
  onSubmit: (email: string) => void;
}

export function EmailStep({isLoading, error, onSubmit}: EmailStepProps) {
  const form = useForm<EmailForm>({
    resolver: yupResolver(emailSchema),
    mode: 'onChange',
    defaultValues: {email: ''},
  });

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit((data) => onSubmit(data.email))}
        className="flex w-full flex-col gap-6"
      >
        <div className="flex flex-col gap-1 text-center">
          <h1 className="font-serif text-3xl text-foreground">
            A page was shared with you
          </h1>
          <p className="text-sm text-muted-foreground">
            Confirm your email to get access.
          </p>
        </div>

        <FormField
          control={form.control}
          name="email"
          render={({field}) => (
            <FormItem>
              <FormControl>
                <Input {...field} type="email" placeholder="Email" autoFocus />
              </FormControl>
              {form.formState.isSubmitted && <FormMessage />}
            </FormItem>
          )}
        />

        {error && (
          <p className="text-center text-sm text-destructive">{error}</p>
        )}

        <Button
          type="submit"
          variant="default"
          size="fill"
          loading={isLoading}
          disabled={!form.formState.isValid}
        >
          Send verification code
        </Button>
      </form>
    </Form>
  );
}
